import { CardProps } from 'components/molecules/Card';
import CardDetailTip from 'components/molecules/Card/Detail/Tip';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actionCreators } from 'store/programItems';
import {
	getImagesFromSelectedContent,
	getItemContentVideoFromSelectedContent,
	getItemRichTextFromSelectedContent,
	getLinkFromSelectedContent,
	getTitleFromSelectedContent,
} from 'store/programItems';

const mapStateToProps = (state: any, ownProps: any): CardProps & any => {
	const selectedContent = ownProps.parentProps;
	return {
		title: getTitleFromSelectedContent(selectedContent),
		isDone: false,
		richText: getItemRichTextFromSelectedContent(selectedContent),
		images: getImagesFromSelectedContent(selectedContent),
		contentVideo: getItemContentVideoFromSelectedContent(selectedContent),
		link: getLinkFromSelectedContent(selectedContent),
	};
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators(actionCreators, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(CardDetailTip as any);
